import { render } from "./DocumentsTable.vue?vue&type=template&id=02db8c72&scoped=true"
import script from "./DocumentsTable.vue?vue&type=script&lang=js"
export * from "./DocumentsTable.vue?vue&type=script&lang=js"

import "./DocumentsTable.vue?vue&type=style&index=0&id=02db8c72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02db8c72"]])

export default __exports__